export enum ETaskStatus {
  pending = 'pending',
  confirmed = 'confirmed',
  completed = 'completed',
  unassigned = 'unassigned',
  declined = 'declined',
  canceled = 'canceled',
  autoCompleted = 'auto_completed',
}
